import Graduation25Image from '../../../../images/configurator/graduations/graduation-g25.svg';
import Graduation50Image from '../../../../images/configurator/graduations/graduation-g50.svg';
import { SizeId } from './sizes';
export const GraduationImage = Object.freeze({
  [SizeId.G25]: Graduation25Image,
  [SizeId.G50]: Graduation50Image,
});
